export default "__VITE_ASSET__Df2djyAM__"